import React, { useState } from "react";
import WaitlistCard from "./WaitlistCard";
import Confetti from "react-confetti";

interface WaitlistModalProps {
  open: boolean;
  onClose: () => void;
  referrerCode?: string | null;
}

const WaitlistModal: React.FC<WaitlistModalProps> = ({ open, onClose, referrerCode }) => {
  const [showConfetti, setShowConfetti] = useState(false);
  if (!open) return null;
  return (
    <>
      {showConfetti && (
        <Confetti width={window.innerWidth} height={window.innerHeight} numberOfPieces={300} recycle={false} />
      )}
      <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/40">
        <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 pt-16 relative border border-[#0a3161] max-h-screen overflow-y-auto my-8">
          <button
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
          <WaitlistCard referrerCode={referrerCode ?? null} onSuccess={() => setShowConfetti(true)} />
        </div>
      </div>
    </>
  );
};

export default WaitlistModal; 